export const getFormValues = state => state.cpdWaiverRequest.form;
export const getShowWaiverForm = state => state.cpdWaiverRequest.showForm;
export const getWaiverData = state => ({
  status: state.cpdWaiverRequest.status,
  year: state.cpdWaiverRequest.form.year,
  verifiableUnits: state.cpdWaiverRequest.verifiableUnits,
});
export const getError = state => state.cpdWaiverRequest.error;
export const getStep = state => state.cpdWaiverRequest.step;
